import React from "react";

export const mainFeaturesContent = {
  badge: {
    text: "Powerful Features",
  },
  heading: "Everything you need to streamline your job sourcing",
  description:
    "Designed specifically for the unique needs of Indian job consultancy firms",
};

export const features = [
  {
    icon: (
      <svg
        className="w-7 h-7 text-black group-hover:scale-110 group-hover:rotate-12 transition-all duration-300"
        fill="none"
        stroke="currentColor"
        strokeWidth={2.5}
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    ),
    title: "Multi-Source Job Fetching",
    description:
      "Fetch jobs from Naukri, LinkedIn, Indeed, company career pages, and government portals all in one place.",
    borderColor: "group-hover:border-blue-200",
    shadowColor: "group-hover:shadow-blue-900/5",
  },
  {
    icon: (
      <svg
        className="w-7 h-7 text-black group-hover:animate-pulse transition-all duration-300"
        fill="none"
        stroke="currentColor"
        strokeWidth={2.5}
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
    ),
    title: "Smart Filters & Tags",
    description:
      "Filter jobs by skills, location, experience level, salary range, and more with intelligent tagging.",
    borderColor: "group-hover:border-indigo-200",
    shadowColor: "group-hover:shadow-indigo-900/5",
  },
  {
    icon: (
      <svg
        className="w-7 h-7 text-black group-hover:translate-y-[-4px] transition-all duration-300"
        fill="none"
        stroke="currentColor"
        strokeWidth={2.5}
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
    ),
    title: "Export to Excel/CSV",
    description:
      "Export structured job data to Excel, CSV, or integrate directly with your ATS system.",
    borderColor: "group-hover:border-emerald-200",
    shadowColor: "group-hover:shadow-emerald-900/5",
  },
  {
    icon: (
      <svg
        className="w-7 h-7 text-black group-hover:scale-110 transition-transform duration-300"
        fill="none"
        stroke="currentColor"
        strokeWidth={2.5}
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>
    ),
    title: "Team Collaboration",
    description:
      "Invite team members, assign roles, share job data, and collaborate in real-time.",
    borderColor: "group-hover:border-amber-200",
    shadowColor: "group-hover:shadow-amber-900/5",
  },
  {
    icon: (
      <svg
        className="w-7 h-7 text-black group-hover:animate-bounce transition-all duration-300"
        fill="none"
        stroke="currentColor"
        strokeWidth={2.5}
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
        />
      </svg>
    ),
    title: "Job Alerts",
    description:
      "Get instant notifications when new jobs matching your criteria are posted.",
    borderColor: "group-hover:border-purple-200",
    shadowColor: "group-hover:shadow-purple-900/5",
  },
  {
    icon: (
      <svg
        className="w-7 h-7 text-black group-hover:rotate-12 transition-transform duration-300"
        fill="none"
        stroke="currentColor"
        strokeWidth={2.5}
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
        />
      </svg>
    ),
    title: "Usage Analytics",
    description:
      "Track your usage, see popular job sources, and optimize your recruitment strategy.",
    borderColor: "group-hover:border-cyan-200",
    shadowColor: "group-hover:shadow-cyan-900/5",
  },
];
